<template>
    <vx-selectable v-model="model"
        placeholder="Select a collection"
        :reduce="option => option.id"
        label="name"
        :loading="loading"
        :options="options"
        :disabled="props.disabled"
        @search="search"
        data-test="group-collection-selectable">
    </vx-selectable>
</template>

<script setup>
import { VxSelectable } from '@voxie/frontend-components';
import { ref } from 'vue';
import { useToasted } from '~/composables/useToasted';
import { groupCollectionsClient } from '~/services';
import debounce from '~/utils/debounce';

const teamId = Spark.state.currentTeam.id;
const toasted = useToasted();

const model = defineModel();

const props = defineProps({
    disabled: {
        type: Boolean,
        default: false,
    }
});

const options = ref([]);
const loading = ref();

const search = debounce((query) => {
    loading.value = true;

    groupCollectionsClient.getGroupCollections({ teamId }, {
        query: query || model.value,
    }).then((response) => {
        options.value = response.data.data;
    }).catch((e) => {
        console.error('Failed to load group collections:', e);
        toasted.global.platform_error();
    }).finally(() => {
        loading.value = false;
    })
}, 300);

search();
</script>
